/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1ProductionstatusesQueryResponse } from '../../types/GetV1Productionstatuses.ts'

export const getV1ProductionstatusesQueryKey = () => [{ url: '/v1/ProductionStatuses' }] as const

export type GetV1ProductionstatusesQueryKey = ReturnType<typeof getV1ProductionstatusesQueryKey>

/**
 * {@link /v1/ProductionStatuses}
 */
export async function getV1Productionstatuses(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1ProductionstatusesQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/ProductionStatuses`, ...requestConfig })
    return res
}

export function getV1ProductionstatusesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1ProductionstatusesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1ProductionstatusesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1ProductionstatusesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Productionstatuses(config)
        },
    })
}

/**
 * {@link /v1/ProductionStatuses}
 */
export function useGetV1Productionstatuses<
    TData = ResponseConfig<GetV1ProductionstatusesQueryResponse>,
    TQueryData = ResponseConfig<GetV1ProductionstatusesQueryResponse>,
    TQueryKey extends QueryKey = GetV1ProductionstatusesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1ProductionstatusesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1ProductionstatusesQueryKey()

    const query = useQuery(
        {
            ...getV1ProductionstatusesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
